import { graphql } from "gatsby"
import * as React from "react"
import styled from "styled-components"
import Layout from "../components/layout"
import BlogPost from "../components/BlogPost"

const StyledBlog = styled.section`
  margin-bottom: 4rem;
  .blog-posts {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    @media only screen and (min-width: 600px) {
      grid-template-columns: 1fr 1fr;
    }
    @media only screen and (min-width: 1000px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`

export interface IBlogPost {
  node: {
    title: string
    slug: string
    description: {
      description: string
    }
    heroImage: {
      title: string
      resize: {
        src: string
      }
    }
  }
}

interface IBlogPageProps {
  data: {
    allContentfulBlogPost: {
      edges: [IBlogPost]
    }
  }
}

export const pageQuery = graphql`
  query BlogQuery {
    allContentfulBlogPost(
      filter: { tags: { in: "dealer9000" } }
      sort: { fields: publishDate, order: DESC }
    ) {
      edges {
        node {
          title
          description {
            description
          }
          slug
          heroImage {
            title
            resize(width: 500) {
              src
              width
              height
            }
          }
        }
      }
    }
  }
`

export default ({ data }: IBlogPageProps) => (
  <Layout>
    <div className="container">
      <StyledBlog>
        <div className="heading">
          <h1>Dealer Insights</h1>
          <h4 className="secondary">
            Read about marketing, news and product updates.
          </h4>
        </div>
        <div className="blog-posts">
          {data.allContentfulBlogPost.edges.map((post: IBlogPost) => (
            <BlogPost
              key={post.node.slug}
              heroAlt={post.node.heroImage.title}
              heroSrc={post.node.heroImage.resize.src}
              slug={post.node.slug}
              title={post.node.title}
              description={post.node.description.description}
            />
          ))}
        </div>
      </StyledBlog>
    </div>
  </Layout>
)
